module.exports = __webpack_public_path__ + "static/media/project-foundermate.8cd07b92.jpg";